export class ListAllRegionsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "regions",
            "baseName": "regions",
            "type": "ListAllRegionsResponseRegions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAllRegionsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
